import { render, staticRenderFns } from "./AdPerformanceReport.vue?vue&type=template&id=5b8de31f&scoped=true&"
import script from "./AdPerformanceReport.vue?vue&type=script&lang=js&"
export * from "./AdPerformanceReport.vue?vue&type=script&lang=js&"
import style0 from "./AdPerformanceReport.vue?vue&type=style&index=0&id=5b8de31f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8de31f",
  null
  
)

export default component.exports